import Swiper, { Navigation, Pagination, EffectFade, A11y } from 'swiper'

Swiper.use([Navigation, Pagination, EffectFade, A11y])

const fn = {
  init: () => {
    const els = document.querySelectorAll('.element-panelslider')
    els.forEach((el) => fn.setupSlider(el))
  },

  setupSlider: (el) => {
    const container = el.querySelector('.swiper')
    const numSlides = container.querySelectorAll('.swiper-slide').length

    if (numSlides > 1) {
      new Swiper(container, {
        slidesPerView: 1,
        speed: 750,
        effect: 'fade',
        loop: true,
        loopedSlides: numSlides,
        navigation: {
          nextEl: el.querySelector('.panel-button-next'),
          prevEl: el.querySelector('.panel-button-prev'),
        },
        pagination: {
          el: el.querySelector('.panel-pagination'),
          clickable: true,
        },
        on: {
          slideChangeTransitionStart: (swiper) => {
            const fractionPagination = swiper.$el
              .closest('.element-panelslider')[0]
              .querySelector('.panel-fraction-pagination')

            if (fractionPagination) {
              fractionPagination.textContent = `${swiper.realIndex + 1} / ${numSlides}`
            }
          },
        },
      })
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
